import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { ErpCommonModule } from '../erp-common/erp-common.module';
import { ArticleTypeSelectionFieldComponent } from './article-type-selection-field/article-type-selection-field.component';
import { DictionaryModule, MaterialModule } from '@sdbn/appclient';

@NgModule({
  declarations: [
    ArticleTypeSelectionFieldComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIModule,
    CommonTranslationModule,
    MaterialModule,
    ReactiveFormsModule,
    DictionaryModule,
    ErpCommonModule
  ],
  exports: [
    ArticleTypeSelectionFieldComponent
  ]
})
export class ArticleCommonModule { }
